function setActiveTab(tabs, panels, activeIndex) {
  tabs.forEach((tab, index) => {
    const isActive = index === activeIndex;
    tab.setAttribute("aria-selected", isActive ? "true" : "false");
    tab.tabIndex = isActive ? 0 : -1;
    tab.classList.toggle("text-text-black", isActive);
    tab.classList.toggle("text-text-black/30", !isActive);
  });

  panels.forEach((panel, index) => {
    panel.hidden = index !== activeIndex;
  });
}

function initTabs(root) {
  const tabs = Array.from(root.querySelectorAll("[data-areas-tab]"));
  const panels = Array.from(root.querySelectorAll("[data-areas-tabpanel]"));
  if (!tabs.length || !panels.length) return;

  setActiveTab(tabs, panels, 0);

  tabs.forEach((tab, index) => {
    tab.addEventListener("click", () => {
      setActiveTab(tabs, panels, index);
    });

    tab.addEventListener("keydown", (event) => {
      let nextIndex = null;

      if (event.key === "ArrowDown" || event.key === "ArrowRight") {
        nextIndex = (index + 1) % tabs.length;
      } else if (event.key === "ArrowUp" || event.key === "ArrowLeft") {
        nextIndex = (index - 1 + tabs.length) % tabs.length;
      } else if (event.key === "Home") {
        nextIndex = 0;
      } else if (event.key === "End") {
        nextIndex = tabs.length - 1;
      }

      if (nextIndex === null) return;

      event.preventDefault();
      setActiveTab(tabs, panels, nextIndex);
      tabs[nextIndex].focus();
    });
  });
}

export function initAreasOfFocus() {
  const root = document.querySelector("[data-areas-of-focus]");
  if (!root) return;

  const tabs = root.querySelector("[data-areas-tabs]");
  if (tabs) initTabs(tabs);
}
